import {createSlice} from "@reduxjs/toolkit";

export const reducerName = "user";
export const initialState = {
    admin: false,
    email: "",
    expiresAt: "",
    name: "!!",
    role: "",
    token: "",
    userId: 0,
    location: "",
    isEmailConfirmed: null,
    hasSubscription: false,
    isLeaveFormFilled: true,
    referralCodeRequest: {
        id: 0,
        userId: 0,
        referralCodeRequestStatus: "",
        expiredAt: "",
        discountAmount: 0
    }
};

const userReducer = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setUser: (state, action) => ({
            ...state,
            ...action.payload
        }),
        clearUser: () => initialState,
        setUserLocation: (state, action) => ({
            ...state,
            location: action.payload
        }),
        setUserReferralCodeRequest: (state, action) => ({
            ...state,
            referralCodeRequest: action.payload
        }),
        setUserSubscription: (state, action) => ({
            ...state,
            hasSubscription: action.payload
        })
    }
});

export default userReducer.reducer;
export const {
    setUser,
    clearUser,
    setUserLocation,
    setUserReferralCodeRequest,
    setUserSubscription,
} = userReducer.actions;
